import { useLanguage } from "@/context/LanguageContext";
import { Chapter, Reveal } from "@/components/atoms";

export const Experience = () => {
  const { t } = useLanguage();
  const e = t.experience;
  return (
    <section id="erfahrung" className="border-t border-hairline" data-testid="experience-section">
      <div className="px-5 md:px-10 pt-20 md:pt-28 pb-12 md:pb-16">
        <Reveal>
          <Chapter num={e.chapter} label={e.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif font-light tracking-tight leading-none text-4xl sm:text-5xl md:text-6xl" data-testid="experience-headline">
            {e.headline}
          </h2>
        </Reveal>
      </div>
      <div className="border-t border-hairline" data-testid="experience-list">
        {e.items.map((item, i) => (
          <Reveal key={i} delay={0.06 * i}>
            <div className="grid md:grid-cols-12 gap-3 md:gap-8 px-5 md:px-10 py-8 md:py-10 border-b border-hairline items-baseline" data-testid={`experience-item-${i}`}>
              <span className="md:col-span-2 font-mono text-[11px] tracking-[0.2em] text-proof">{item.date}</span>
              <div className="md:col-span-5">
                <h3 className="font-serif text-2xl md:text-3xl font-light tracking-tight leading-tight">{item.title}</h3>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">{item.org}</p>
              </div>
              <p className="md:col-span-5 text-base md:text-lg font-light leading-relaxed text-ink/80">{item.note}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="px-5 md:px-10 py-12 md:py-16 grid md:grid-cols-12 gap-8">
        <Reveal className="md:col-span-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">{e.weiterLabel}</p>
          <p className="mt-4 text-base md:text-lg font-light leading-relaxed text-ink/80">{e.weiter}</p>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">{e.ausbildungLabel}</p>
          <p className="mt-4 text-base md:text-lg font-light leading-relaxed text-ink/80">{e.ausbildung}</p>
        </Reveal>
      </div>
    </section>
  );
};
